const version = {
    "version": "2.2.0"
}

export default version